import {createStyles, Divider, Paper, Text} from '@mantine/core';
import React from 'react';

export interface ExplainerStep {
  title: string;
  description: string;
}

export interface ExplainerProps {
  headerTitle: string;
  steps: ReadonlyArray<ExplainerStep>;
}

const useStyles = createStyles((theme) => ({
  explainerCard: {
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    overflow: 'hidden',
  },
  explainerHeader: {
    backgroundColor: theme.colors.blue[0],
    padding: theme.spacing.sm,
  },
  explainerItem: {
    display: 'flex',
    gap: theme.spacing.sm,
    padding: theme.spacing.sm,
  },
  stepCircle: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: theme.colors.blue[1],
    color: theme.colors.blue[8],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
    flexShrink: 0,
  },
}));

export default function Explainer({headerTitle, steps}: ExplainerProps): JSX.Element {
  const {classes} = useStyles();

  return (
    <Paper className={classes.explainerCard}>
      <div className={classes.explainerHeader}>
        <Text weight={600} size="sm">
          {headerTitle}
        </Text>
      </div>
      {steps.map((step, index) => (
        <React.Fragment key={`${index}-${step.title}`}>
          <Divider />
          <div className={classes.explainerItem}>
            <div className={classes.stepCircle}>{index + 1}</div>
            <div>
              <Text weight={600} size="sm">
                {step.title}
              </Text>
              <Text size="xs" color="dimmed">
                {step.description}
              </Text>
            </div>
          </div>
        </React.Fragment>
      ))}
    </Paper>
  );
}
